const classColors: any = {
    'background': '#475569',
    'mucin': '#b36bd8',
    'tumor': '#c80000',
    'normal': '#00ff00',
    'stroma': "#96c896",
    'necrosis': '#0000ff',
    'lymphocytes': '#87de40',
    'macrophage': '#295298',
};

const qualityColors: any = {
    'good': 'transparent',
    'poor': 'red',
    'dissociated': 'yellow',
}

const colorMap: any = {
    'background': classColors.background,
    'mucin': classColors.mucin,
    'non tumor': classColors.normal,
    'normal': classColors.normal,
    'normal organ': classColors.normal,
    'non': classColors.normal,
    'tumor': classColors.tumor,
    'stroma': classColors.stroma,
    'necrosis': classColors.necrosis,
    'lymphocyte': classColors.lymphocytes,
    'lymphocytes': classColors.lymphocytes,
    'lymphocyte infiltrate': classColors.lymphocytes,
    'lymphocytes infiltrate': classColors.lymphocytes,
    'macrophage': classColors.macrophage
};

export default colorMap;
export { qualityColors };